import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { syncMapaFaseRoute, stopMapaFaseRouteSync } from './mapaFaseSocketBridge';

class MapaRouteSync extends Component {
  componentDidMount() {
    this.applySync();
    this.unlisten = this.props.history.listen(loc => {
      syncMapaFaseRoute(loc.pathname);
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.config !== this.props.config ||
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.applySync();
    }
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
    stopMapaFaseRouteSync();
  }

  applySync() {
    syncMapaFaseRoute(this.props.location.pathname, this.props.config);
  }

  render() {
    return null;
  }
}

export default withRouter(
  connect(state => ({
    config: state.auth.config,
  }))(MapaRouteSync),
);
